import React from 'react';
import { connect } from 'react-redux';
import { signInCheck, getScreenName } from '../../common/CheckUserStatus';
import AuthModalDesktop from './../../../userauth/components/AuthModalDesktop';
import Modal from '../../common/Modal';
import { showModal, hideModal } from "../../../actions/modal.js";
import { signout } from "./../../../userauth/actions/signinAction";
import {generateEvent} from "../../../utils/dataGrinch";
import properties from "../../../modules/ajio-util/properties";
import isNode from "../../../modules/ajio-util/isNode";
import { getReferralFeatureEnableFlag, getRefereeEnableFlag } from "../../../Flags/selectors";
import { gtmEventPush, gtmPagePush, segmentEventPush } from '../../../modules/ga/GTMdatalayer';
import screen from '../../../utils/pageType';
import Icon from "../../../refresh/atoms/Icon";
import { getLuxeFlags } from '../../../Flags/selectors';
import {
  getUaas,
  getAvailableDomainsFlag,
  getFraudReductionForEmployeeCouponsFlag
} from '../../../refresh/selectors/featureFlagsSelector';
import { getCurrentStore } from '../../../refresh/selectors/metaData';
import { getStreetFlags } from '../../../refresh/selectors/featureFlagsSelector';
import { STREET_STORE, LUXE_STORE, AJIO_STORE } from '../../../constants/constant';
import { isRilDomain } from '../../../utils/common';

class GuestHeader extends React.Component {
constructor(){
  super();
}

linkClick(link, name, type){
  generateEvent({
    Event : type,
    value : {
      LinkName : name,
      LinkUrl : link,
      Screen: "Desktop"
    }
  })
  //window.location = link;
}
handleClose = () => {
    gtmEventPush({
      event:'header_clicks',
      click_text:'close',
      page_type:'user account screen'
    });
    let pageName = localStorage.getItem('LoginModelType') || ''
    gtmEventPush({
      page_name: pageName,
      page_type: 'user account screen',
      event: 'user_account_interactions',
      category: 'user account interactions',
      action: 'close',
    })
    localStorage.removeItem('LoginModelType');
}
  render() {
    const {
      basicInfo = {},
      httpError = {},
      flags = {},
      newDesignLuxe,
      luxeStoreEnabled,
      streetStoreEnabled,
      isStreetStore,
    } = this.props;
    let screenName = "";
    let {metaData : { sis = false, stores, name = '' } = {}} = this.props;
    let visitButtonUrl = "";
    if(name === 'luxe') visitButtonUrl = properties.getProperty("parentUrl")
    else  visitButtonUrl = properties.getProperty("luxeURL")
    const visitStoreButtonClick = (store = '') => {
      if(store === LUXE_STORE) return properties.getProperty("luxeURL");
      else if(store === STREET_STORE) return properties.getProperty("streetURL");
      else return properties.getProperty("parentUrl");
    }
    let { error : { message = "", originator = "", errorType = "" } = {} } = httpError;
    let isSignedIn = "";
    if(!isNode()){
      isSignedIn = signInCheck();
      screenName = getScreenName();
    }
    if(Object.keys(basicInfo).length){
      ({userName : isSignedIn} = basicInfo);
      screenName = isSignedIn;
    }

    const referralFlowEnabled = getReferralFeatureEnableFlag(flags) && getRefereeEnableFlag(flags);
    const selfCareUrl = (sis && !newDesignLuxe && !isStreetStore) ? `${properties.getProperty("parentUrl")}/selfcare` : "/selfcare";
    const redirectToMyAccount = (sis && !newDesignLuxe && !isStreetStore) ? `${properties.getProperty("parentUrl")}/my-account/orders` : "/my-account/orders"
    
    const { isDesktopThemeEnable } = getLuxeFlags(flags);
    const { storeName, isEmailVerified = false, personalInfo = {}, isUaas, fraudReductionForEmployeeCouponsFlag, availableDomains } = this.props;
    const rilDomain = personalInfo?.profile?.displayUid && isRilDomain(availableDomains, personalInfo?.profile?.displayUid);
    const isFraudReductionForEmpApplicable = window?.location?.pathname == "/" &&
      fraudReductionForEmployeeCouponsFlag && isUaas && rilDomain && !personalInfo?.profile?.emailVerified;
    const luxe = storeName === 'luxe';
    let headerClass;
    if(isDesktopThemeEnable === "ON" && storeName === "luxe") headerClass = 'luxe-newdesign'
    else if (isDesktopThemeEnable === "OFF" && storeName === "luxe") headerClass = 'luxe-newdesign flag-off'
    else headerClass = ''
    return (
      <div className={`${headerClass} guest-header`}>
        {isSignedIn ? (
          <ul>
            <li>
              <span
                className="ignore-sentence-case"
                tabIndex={0}
                role={referralFlowEnabled ? undefined : 'button'}
                aria-label={`Logged in user ${screenName}`}
              >
                <span aria-hidden="true">
                  {luxe ? <strong>{screenName}</strong> : screenName}
                </span>
              </span>
 
 
              {!referralFlowEnabled  && (
                   <Modal
                name="sign-in-up"
                className={`modal-sign-in-up ${
                  referralFlowEnabled ? 'referral-modal-sign-in-up' : ''
                }`}
                id="login-modal"
                errorMsg={this.props?.message}
              >
                <div className="modal-login-container">
                  <AuthModalDesktop destSrc="login" viewSiteAs="desktop" />
                </div>
              </Modal>
              )}
            </li>
            <li>
              <a
                href={redirectToMyAccount}
                onClick={() => {
                  this.linkClick('/my-account/orders', 'MY ACCOUNT', 'HeaderClick');
                }}
                aria-label="My Account"
              >
                {luxe ? <strong>My Account</strong> : 'My Account'}
              </a>
              {isFraudReductionForEmpApplicable && (
                <img
                  src={`${properties.getProperty(
                    'imageBaseUrl'
                  )}/static/img/icon-info-circle-red.svg`}
                  alt="Information icon"
                  className="verified-img"
                />
              )}
            </li>
            {/* <li className="dapp"><a href="/c/mobile-apps"> Download App</a></li> */}
            <li>
              <a
                onClick={() => {
                  this.props.signout(() => {
                    localStorage.removeItem('attributionToken');
                    localStorage.removeItem('cartAttributionMap');
                    localStorage.removeItem('priceReveal_v2');

                    const loginStatus = signInCheck().length ? 'Login' : 'Not Login';
                    gtmEventPush({
                      event: 'logout_success',
                      page_url: window.location.href,
                      user_type: loginStatus,
                      page_type: 'user sign out',
                      page_name: 'user sign out'
                    });
                    // Segment push Event
                    segmentEventPush({
                      event: 'Logout Clicked',
                      logout_status: 'success',
                      screen_name: 'user sign out'
                    });
                    
                    this.linkClick('/logout', 'LOGOUT', 'HeaderClick');
                    window.location = '/';
                    window?.copilot?.users.unset();
                  });
                }}
                title='acts as button'
                tabIndex={0}
                
              >
                {luxe ? <strong>Sign Out</strong> : 'Sign Out'}
              </a>
            </li>
            <li>
              <a
                href={selfCareUrl}
                onClick={() => {
                  this.linkClick('/selfcare', 'CUSTOMER CARE', 'HeaderClick');
                }}
                aria-label="Customer Care"
              >
                {luxe ? <strong>Customer Care</strong> : 'Customer Care'}
              </a>
            </li>
            {storeName !== '' && storeName?.toLowerCase() !== AJIO_STORE && (
              <li className="visit-ajio ajio_color">
                <a href={visitStoreButtonClick('')} aria-label="Visit Ajio">
                  {luxe ? <strong>Visit AJIO</strong> : 'Visit AJIO'}
                </a>
              </li>
            )}
            {luxeStoreEnabled && storeName !== LUXE_STORE && (
              <li className="visit-ajio">
                <a href={visitStoreButtonClick(LUXE_STORE)} aria-label="Visit Ajioluxe">
                  {luxe ? <strong>Visit AJIOLUXE</strong> : 'Visit AJIOLUXE'}
                </a>
              </li>
            )}
            {streetStoreEnabled === 'ON' && storeName !== STREET_STORE && (
              <li className="visit-ajio street_gradient_color">
                <a href={visitStoreButtonClick(STREET_STORE)} aria-label="Visit Ajio Street">
                  {luxe ? <strong>Visit AJIO Street</strong> : 'Visit AJIO Street'}
                </a>
              </li>
            )}
          </ul>
        ) : (
          <ul>
              <li>
                <span
                  id="loginAjio"
                  tabIndex={0}
                  role="button"
                  onClick={() => {
                    this.linkClick('/login', 'LOGIN', 'HeaderClick');
                    this.props.showModal('sign-in-up');
                    segmentEventPush({
                      event: 'Login / Signup Initiated',
                      screen_name: 'login/signup screen',
                      status: ''
                    });
                  }}
                  className={`${newDesignLuxe ? 'luxe-newdesign' : ''}  login-form login-modal`}
                  aria-label="Sign In / Join Ajio"
                >
                  Sign In / Join AJIO
                </span>
                <Modal
                  onClose={this.handleClose}
                  name="sign-in-up"
                  ariaLabel="Signin/Signup"
                  className={`modal-sign-in-up ${
                    referralFlowEnabled ? 'referral-modal-sign-in-up' : ''
                  }`}
                  id="login-modal"
                  errorMsg={this.props.message}
                >
                  <div className="modal-login-container">
                    <AuthModalDesktop destSrc="login" viewSiteAs="desktop" />
                  </div>
                </Modal>
              </li>
            {/* <li className="dapp"><a href="/c/mobile-apps"> Download App</a></li> */}
            <li>
              <a
                href={selfCareUrl}
                onClick={() => {
                  this.linkClick('/selfcare', 'CUSTOMER CARE', 'HeaderClick');
                }}
                aria-label="Customer Care"
              >
                {luxe ? <strong>Customer Care</strong> : 'Customer Care'}
              </a>
            </li>
            {storeName !== '' && storeName?.toLowerCase() !== AJIO_STORE && (
              <li className="visit-ajio ajio_color">
                <a href={visitStoreButtonClick('')} aria-label="Visit Ajio">
                  {luxe ? <strong>Visit AJIO</strong> : 'Visit AJIO'}
                </a>
              </li>
            )}
            {luxeStoreEnabled && storeName !== LUXE_STORE && (
              <li className="visit-ajio">
                <a href={visitStoreButtonClick(LUXE_STORE)} aria-label="Visit Ajioluxe">
                  {luxe ? <strong>Visit AJIOLUXE</strong> : 'Visit AJIOLUXE'}
                </a>
              </li>
            )}
            {streetStoreEnabled === 'ON' && storeName !== STREET_STORE && (
              <li className="visit-ajio street_gradient_color">
                <a href={visitStoreButtonClick(STREET_STORE)} aria-label="Visit Ajio Street">
                  {luxe ? <strong>Visit AJIO Street</strong> : 'Visit AJIO Street'}
                </a>
              </li>
            )}
          </ul>
        )}
      </div>
    );
  }
}
const mapStateToProps = (state, ownProps) => {
  const { userInfoReducer= {}, httpError={}, metaData = {}, flags = {}, personalInfo = {} } = state;
  const { userName = "" } = userInfoReducer;
  const { error = {} } = httpError;
  const { isDesktopThemeEnable } = getLuxeFlags(flags);
  const { isThemeEnableWeb: streetStoreEnabled } = getStreetFlags(state);
  const storeName = getCurrentStore(state);
  const newDesignLuxe = isDesktopThemeEnable === 'ON' && storeName === 'luxe';
  const isStreetStore = streetStoreEnabled === 'ON' && storeName === STREET_STORE;
  return{
    personalInfo,
    newDesignLuxe,
    httpError,
    userName,
    statusCode: error.statusCode,
    errorType: error.errorType,
    message: error.message,
    metaData,
    flags,
    storeName,
    luxeStoreEnabled: isDesktopThemeEnable,
    streetStoreEnabled,
    isStreetStore,
    isUaas: getUaas(state),
    fraudReductionForEmployeeCouponsFlag: getFraudReductionForEmployeeCouponsFlag(state),
    availableDomains: getAvailableDomainsFlag(state),
  };
}
const mapDispatchToProps = (dispatch) => {
  return {
    showModal: (name, config) => {
      dispatch(showModal(name, config));
    },
    hideModal: name => {
      dispatch(hideModal(name));
    },
    signout: (cb) => {
      dispatch(signout(cb));
    }
  };
};
export default GuestHeader = connect(mapStateToProps, mapDispatchToProps)(GuestHeader);